import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-26d7ec66"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  title: "Toggle Menu"
};
const _hoisted_2 = ["title"];
const _hoisted_3 = ["title"];
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Router, { COURSES_PATH, SETTINGS_PATH } from '@/router';
import useCourses from '@/composables/global/use-courses';
import useInitLoader from '@/composables/global/use-init-loader';
import useResponsiveness from '@/composables/global/use-responsiveness';
import useShellHeader from '@/composables/global/use-shell-header';
import useViewer from '@/composables/global/use-viewer';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheShellSideMenuButtons',
  props: {
    minified: {
      type: Boolean
    }
  },
  emits: ["navToRoute"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      courses
    } = useCourses();
    const {
      appDataInitialized
    } = useInitLoader();
    const {
      mdUp
    } = useResponsiveness();
    const {
      toggleMenuSize,
      textColor
    } = useShellHeader();
    const {
      isAdmin
    } = useViewer();
    const {
      t
    } = useI18n({
      useScope: 'global',
      messages: {
        en: {
          Tooltips: {
            settings: 'Settings',
            courses: 'Courses'
          }
        },
        es: {
          Tooltips: {
            settings: 'Configuración',
            courses: 'Cursos'
          }
        }
      }
    });
    const isLoading = ref(true);
    const hasCoursesAccess = computed(() => {
      var _courses$value;
      return isAdmin.value || ((_courses$value = courses.value) === null || _courses$value === void 0 ? void 0 : _courses$value.length) > 1;
    });
    const settingsColor = computed(() => {
      const inSettings = Router.currentRoute.value.path.includes(SETTINGS_PATH);
      return inSettings ? 'primary' : 'menu-icon';
    });
    const coursesColor = computed(() => {
      const inCourses = Router.currentRoute.value.path.includes(COURSES_PATH);
      return inCourses ? 'primary' : 'menu-icon';
    });
    const menuButtonColor = computed(() => {
      if (textColor.value && props.minified) return textColor.value;else if (props.minified) return 'var(--ion-color-toolbar-text)';else return 'var(--ion-color-menu-icon)';
    });
    onMounted(async () => {
      await appDataInitialized();
      isLoading.value = false;
    });
    return (_ctx, _cache) => {
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_buttons = _resolveComponent("ion-buttons");
      const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle");
      const _component_ion_col = _resolveComponent("ion-col");
      const _component_ion_row = _resolveComponent("ion-row");
      const _component_ion_grid = _resolveComponent("ion-grid");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(_component_ion_buttons, null, {
        default: _withCtx(() => [_createVNode(_component_ion_button, {
          style: _normalizeStyle({
            '--color': menuButtonColor.value
          }),
          disabled: isLoading.value,
          onClick: _unref(toggleMenuSize)
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_ion_icon, {
            slot: "icon-only",
            icon: _ctx.minified ? 'menu' : 'chevron-back'
          }, null, 8, ["icon"])])]),
          _: 1
        }, 8, ["style", "disabled", "onClick"])]),
        _: 1
      }, 512), [[_vShow, _unref(mdUp)]]), _withDirectives(_createVNode(_component_ion_buttons, {
        class: "ion-margin-top",
        mode: "md"
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_grid, {
          class: "ion-no-padding"
        }, {
          default: _withCtx(() => [_createVNode(_component_ion_row, null, {
            default: _withCtx(() => [_createVNode(_component_ion_col, null, {
              default: _withCtx(() => [_createVNode(_component_ion_menu_toggle, {
                "auto-hide": false
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_button, {
                  onClick: _cache[0] || (_cache[0] = $event => emit('navToRoute', _unref(SETTINGS_PATH))),
                  color: settingsColor.value,
                  mode: "md"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", {
                    title: _unref(t)('Tooltips.settings')
                  }, [_createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: "settings"
                  })], 8, _hoisted_2)]),
                  _: 1
                }, 8, ["color"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _withDirectives(_createVNode(_component_ion_row, null, {
            default: _withCtx(() => [_createVNode(_component_ion_col, null, {
              default: _withCtx(() => [_createVNode(_component_ion_menu_toggle, {
                "auto-hide": false
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_button, {
                  onClick: _cache[1] || (_cache[1] = $event => emit('navToRoute', _unref(COURSES_PATH))),
                  color: coursesColor.value,
                  mode: "md"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", {
                    title: _unref(t)('Tooltips.courses')
                  }, [_createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: "library"
                  })], 8, _hoisted_3)]),
                  _: 1
                }, 8, ["color"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 512), [[_vShow, hasCoursesAccess.value]])]),
          _: 1
        })]),
        _: 1
      }, 512), [[_vShow, !_ctx.minified]])], 64);
    };
  }
});